/**
 *
 */

var Tabs = (function($) {
  function initTabs() {
    $(".sustainability-filters__list-item").click(function() {
      var $clickedItem = $(this);
      var currentTab = $clickedItem.attr("data-id");

      // Si ya está activo, no hacer nada
      if ($clickedItem.hasClass("sustainability-filters__list-item--active"))
        return;

      // Aplicar clase activa antes de la animación
      $(".sustainability-filters__list-item").removeClass(
        "sustainability-filters__list-item--active"
      );
      $clickedItem.addClass("sustainability-filters__list-item--active");

      // Mostrar nuevo tab
      $(".sustainability-tab:visible").fadeOut(200, function() {
        $(".sustainability-tab[id='" + currentTab + "']").fadeIn(200);
      });
    });
  }

  function moveFilters() {
    $(".sustainability-filters").each(function() {
      $(this).insertAfter($(".sustainability-tab .heading"));
    });
  }

  function init() {
    if (!$(".sustainability-tabs").length) {
      return;
    }

    if ($(window).width() < 990) {
      moveFilters();
    }

    setTimeout(() => {
      initTabs();
    }, 1000);
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Tabs.init);
